import { GraphEdge } from '../GraphEdge'

export function generateConcatenationEdges(templateField, templateFields, metadata) {
  const gov = templateField.field.concatenation_governance
  const fieldId = templateField.field_id

  // loop over dependencies and generate edges for each
  const edges = gov.concatenation_governance_patterns.reduce((memo, item) => {
    // direct field ones are easy
    if (item.concatenation_field_id) {
      memo.push(new GraphEdge(item.concatenation_field_id, fieldId))
      return memo
    }

    /*
     *  list ones are a bit more complicated
     *  the simplest way is to just update anytime anything tied to a list updates.
     *  we can probably get smarter in the future, but it should be good enough for now.
     */
    const listId = item.concatenation_list_id
    const templateFieldForListId = metadata.columnsByListId[listId] || []
    const edgesToAdd = templateFieldForListId.map(colDep => {
      return new GraphEdge(colDep.field_id, fieldId)
    })
    memo.push.apply(memo, edgesToAdd)
    return memo
  }, [])

  // return the result
  return edges
}
